// Admin pages module - vanilla JavaScript implementation
window.BC = window.BC || {};
window.BC.admin_pages = {
  init: function() {

    // Initialize Bootstrap tooltips
    if (window.bootstrap && window.bootstrap.Tooltip) {
      document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function(element) {
        new bootstrap.Tooltip(element);
      });
    }

    editableTasks();
    
    // Handle new task button click
    const newTaskButton = document.getElementById('new_task_button');
    if (newTaskButton) {
      newTaskButton.addEventListener('click', function() {
        const newTaskElement = document.getElementById('new-task');
        if (newTaskElement) {
          newTaskElement.style.display = 'block';
        }
      });
    }

    taskFilters();

    // TYPEAHEADS - All single-model typeaheads migrated to simple-typeahead Stimulus controller
    // Main navbar search uses standard form submission (no JavaScript needed)
  }
};

// DEPRECATED: Old Bloodhound initialization functions removed - replaced by simple-typeahead controller
// These were used for single-model typeaheads which are now handled by the Stimulus controller

// HELPER FUNCTIONS
// DEPRECATED: Old typeahead helper functions removed - replaced by simple-typeahead controller
// Only refreshContact remains as it's still used by the Stimulus controller

function refreshContact(datum, contacttype) {
  const infoContainer = document.getElementById(contacttype + "_info");
  if (infoContainer) {
    const companyName = infoContainer.querySelector('.contact_company_name');
    const street = infoContainer.querySelector('.contact_street');
    const cityStateZip = infoContainer.querySelector('.contact_city_state_zip');
    const phone = infoContainer.querySelector('.contact_phone');
    const email = infoContainer.querySelector('.contact_email');
    const website = infoContainer.querySelector('.contact_website');
    
    if (companyName) companyName.innerHTML = datum.company_name || '';
    if (street) street.innerHTML = datum.basic_address["street"] || '';
    if (cityStateZip) cityStateZip.innerHTML = datum.basic_address["citystatezip"] || '';
    if (phone) phone.innerHTML = datum.basic_address["phone"] || '';
    if (email) email.innerHTML = datum.basic_address["email"] || '';
    if (website) website.innerHTML = datum.basic_address["website"] || '';
  }
  
  const idField = document.getElementById(contacttype + '_id');
  if (idField) idField.value = datum.id || '';
  
  const fullNameField = document.getElementById('transaction_' + contacttype + '_full_name');
  if (fullNameField) fullNameField.value = datum.full_name || '';
}

// Make refreshContact globally available for the simple typeahead controller
window.refreshContact = refreshContact;

